/**
 * @param {*} hNode
 * @returns {(value: string) => string}
 */
// eslint-disable-next-line no-unused-vars
const toUpperCase = hNode => value => value.toString().toUpperCase();

export default toUpperCase;
